"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
function useMinifiedActions() {
    var theme = (0, core_1.useTheme)();
    // Minified actions are used only in xs and sm devices.
    return !(0, core_1.useMediaQuery)(theme.breakpoints.up('md'));
}
exports.default = useMinifiedActions;
